export default {"src":"/_next/static/media/clariant.a03f0993.svg","height":62,"width":213,"blurWidth":0,"blurHeight":0};